export const isSixthPageAndNoNearestTurn = (
  steps,
  isFastNobat
) => {
  const condition = steps === 7 && isFastNobat === false;

  return condition;
};
